<template>
  <div class="paragraph">
    <h3 style="color: #C0BBB4">{{content.metadata.pres_title}}</h3>
    <div class="begin">{{content.metadata.pres_first}}</div>
    <p class="begin">{{content.metadata.pres_second}}</p>
  </div>
</template>

<script>
export default {
    name: 'Description',
    props: ['content']
}
</script>

<style scoped lang="scss">
    @import '@/styles/constants.scss';

    .paragraph {
        color: map-get($colors, primary);
        .begin {
            color: #8AB9BB;
            text-align: justify;
        }
    }
</style>